module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/icons/KR-c6d27a90dfa317a0f5949c19ac5e0afb.svg";